module.exports = __webpack_public_path__ + "media/images/training_case7-742d9d1770027fb9761f9a82c47dbd46.jpg";